
$(document).on("click", ".question_product,.faq_question", function(e) { 
 if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
 } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
 }
});

$(document).on("click", "body.strawberry-milks a.button[href='#'], body.template_product a.button[href='#']", function(e) { 
     e.preventDefault();
   document.querySelector('.landing_page_product').scrollIntoView({ 
  behavior: 'smooth' 
})
});

$(document).on("click", ".custom_men-women_item", function(e) { 
$(this).parents('.custom_men-women').find('.custom_men-women_item').removeClass('active');
$(this).addClass('active');
var gender = $(this).attr('data_tab');
$(this).parents('.landing_product_info').find('.product_property_gender').val(gender);
});
$(document).on("click", "body .upsell_products_slider_main_item .quick-add__submit", function(e) { 
setTimeout(function () {
$('button.drawer__close').trigger('click');
}, 1500);
});



$(document).ready(function(){
    $('.upsell_products_slider_main').slick({
  dots: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true,
    prevArrow: $('.prev_upsell'),
    nextArrow: $('.next_upsell'),
    appendDots: $('.dots_upsell'),
  cssEase:'linear',
  responsive: [
    {
      breakpoint: 915,
      settings: {
        speed: 300,
        slidesToShow: 2, 
      }
    }
  ]
});
});



$(document).on("mousemove touchstart", "body", function(e) { 
if( $('.upsell_products_slider_main:not(.slick-initialized)').length ) {
    $('.upsell_products_slider_main:not(.slick-initialized)').slick({
  dots: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true,
    prevArrow: $('.prev_upsell'),
    nextArrow: $('.next_upsell'),
    appendDots: $('.dots_upsell'),
  cssEase:'linear',
  responsive: [
    {
      breakpoint: 915,
      settings: {
        speed: 300,
        slidesToShow: 2, 
      }
    }
  ]
});
}
});



$(document).on("click", '.product_remove', function(e) {
$(this).removeClass('active').hide();
$('.product_added').addClass('active').show();
$('.product_removed_price').hide();
$('.product_added_price').show();
});


$(document).on("click", '.product_added', function(e) {
$(this).removeClass('active').hide();
$('.product_remove').addClass('active').show();
$('.product_removed_price').show();
$('.product_added_price').hide();
});

$(document).on("click", 'button#CartDrawer-Checkout', function(e) {
  e.preventDefault();
if( $('.product_added.active').length ) {

var id = $('.product_added.active').attr('variant_id'); 
var this_element =  jQuery(this);
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
location.href ='/checkout';
 }, 
 error: function (data) { 
location.href ='/checkout';
 } 
});
} else {
  
location.href ='/checkout';
}
});


$(document).on("change", '.product_option_select input', function(e) { 
var selected_value = jQuery(this).val();
jQuery(this).parent().parent().find('.add_to_cart_ajax').attr('variant_id',selected_value);
});

jQuery(document).on('click','.add_to_cart_ajax',function(){ 
var this_element = jQuery(this);
jQuery(this).addClass('loading');
var ID = jQuery(this).attr("variant_id"); 
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: ID
},
  dataType: 'json', 
 success: function (data) { 
jQuery("cart-drawer").load(location.href + " #CartDrawer");
setTimeout(function() {
jQuery("cart-drawer").removeClass('is-empty').addClass('active');
jQuery("body ").addClass('overflow-hidden');
this_element.removeClass('loading');
}, 2000);
 } 
 });
});